<template>
  <div>
  <section class="">
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li><a href="/about">關於我們</a></li>
                <li class="active">內容</li>
            </ol>
            <div class="row">
                <div class="col-sm-2">
                    <div class="aside_menu">
                        <h4 class="title">關於我們</h4>
                        <ul class="list-unstyled">
                            <li class="active item"><a href="/about">關於我們</a></li>
                            <li class="item"><a href="">我們的會員</a></li>
                            <li class="item"><a href="/privacy">隱私權政策</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-10">
                    <article>
                        <h3 class="title">關於i80</h3>
                        <p style="font-size:16px;">
                          i80諧音取自「愛幫您」這個緣起於愛，我們以愛為出發點，即我幫您-您幫我。
  我們設計的不只是平台而是一種架構，在我們架構裡，沒有貧窮，也沒有人會失業，我們讓「失業與貧窮」這個詞失去意義。人不應該到企業去找工作，應該是給人工作的人。所有的人都是創業家，我們創造了更新、更好的體系。因為創業精神是人的基本特質。
  我們的宗旨就「讓每一個人都成為自己時間的主人，過自己想要的生活，做自己喜歡的事情，賺自己需要財富！」。
                        <br/><br/>
                        <strong>我們要如何做到?</strong> 我們透過店家的串聯成為一個大商圈，將消費者集結成聯盟，並創建人人都是老闆的平台。
                        要改變傳統產業利潤分配模式，我們需要同舟共濟一起合作，相互進行商圈宣傳及舉辦活動，創造消費者和店家雙贏的局面。
                        <br/><br/>
                        <strong>我們該如何合作?</strong>
                        如果你認同我們的理念，請將我們的理念介紹給親友，讓他加入我們成為會員，成為消費者聯盟的一份子。成為會員後，到聯盟的商店購買產品即有回饋點數。
                      </p>
                      <iframe width="560" height="315" src="https://www.youtube.com/embed/PQtCtw3DP4w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </article>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'About',
  metaInfo: {
    title: '愛幫您-關於我們',
    meta: [{
      name: '愛幫您-關於我們',
      content: '我們正在推廣世界銀行的概念，讓貧窮消失在世界上'
    }],
    link: [{
      rel: 'about',
      href: 'https://www.i80.com.tw/about'
    }]
  },
  data () {
    return {
      rowData: {}
    }
  },
  mounted: function () {
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ])
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// About.vue?0f25bf0c